import { render, staticRenderFns } from "./OnlinePaymentCard.vue?vue&type=template&id=24efe644&scoped=true"
import script from "./OnlinePaymentCard.vue?vue&type=script&lang=js"
export * from "./OnlinePaymentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24efe644",
  null
  
)

export default component.exports